import cleanData from './cleanData';
import getLandingSession from './getLandingSession';

/**
 * Sets the landing session data
 * @param {object} landing
 */
const setLandingSession = (landing = {}) => {
  landing = cleanData(landing);
  const landingSession = getLandingSession();

  // If provider ids are the same just merge the data
  if (
    typeof landingSession.providerID === 'string' &&
    typeof landing.providerID === 'string' &&
    landingSession.providerID.length > 1 &&
    landingSession.providerID === landing.providerID
  ) {
    landing = Object.assign({}, landingSession, landing);
  }

  sessionStorage.setItem('landing', JSON.stringify(landing));
};

export default setLandingSession;
